export const findShowMethodForModal = (modalReferences, modalName) => {
    if (!modalReferences || !modalName || !modalReferences.has(modalName)) {
        return __BATCH__ ? () => {} : null;
    }

    return modalReferences.get(modalName);
};

export default {
    findShowMethodForModal,
};
